import React from "react";
import { Button, Form, Pagination } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import User from "../../../../../../images/user.png";
import PostHandler from "../../../../../../elements/PostHandler";
import moment from "moment";
import { toast } from "react-toastify";
import { removeCommentPost } from "../../../../../../redux/states/fanAnalytics/thunk";
import CustomPagination from "../../../../../CustomPagination";

const CommentPost = (props) => {
  const {
    setFilter,
    filter,
    handlePreviousClick,
    handleNextClick,
    handlePostDetails,
    getCommentPostList,
  } = props;
  const tableData = useSelector((state) => state.fanAnalytics)?.allCommentPost;
  const dispatch = useDispatch();

  const deleteCommentPost = (dta) => {
    const val = {
      postCommentId: dta?._id,
    };
    dispatch(removeCommentPost(val))
      .unwrap()
      .then((res) => {
        toast.success(res.message);
        getCommentPostList();
      })
      .catch((err) => {
        toast.error(err.message);
      });
  };

  const tableDatas = [
    {
      title: "publishing and graphic design, Lorem ipsum...",
      PostImg:
        "https://image.shutterstock.com/image-photo/full-hd-image-ladybird-on-260nw-1952398060.jpg",
      UserImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      UserName: "Jane Cooper",
      UserEmail: "suffescom@gmail.com",
      ArtistImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      ArtistName: "Jane Cooper",
      ArtistEmail: "suffescom@gmail.com",
      Date: "June 1, 2020, 08:22 AM",
    },
    {
      title: "publishing and graphic design, Lorem ipsum...",
      PostImg:
        "https://image.shutterstock.com/image-photo/full-hd-image-ladybird-on-260nw-1952398060.jpg",
      UserImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      UserName: "Jane Cooper",
      UserEmail: "suffescom@gmail.com",
      ArtistImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      ArtistName: "Jane Cooper",
      ArtistEmail: "suffescom@gmail.com",
      Date: "June 1, 2020, 08:22 AM",
    },
    {
      title: "publishing and graphic design, Lorem ipsum...",
      PostImg:
        "https://image.shutterstock.com/image-photo/full-hd-image-ladybird-on-260nw-1952398060.jpg",
      UserImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      UserName: "Jane Cooper",
      UserEmail: "suffescom@gmail.com",
      ArtistImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      ArtistName: "Jane Cooper",
      ArtistEmail: "suffescom@gmail.com",
      Date: "June 1, 2020, 08:22 AM",
    },
    {
      title: "publishing and graphic design, Lorem ipsum...",
      PostImg:
        "https://image.shutterstock.com/image-photo/full-hd-image-ladybird-on-260nw-1952398060.jpg",
      UserImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      UserName: "Jane Cooper",
      UserEmail: "suffescom@gmail.com",
      ArtistImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      ArtistName: "Jane Cooper",
      ArtistEmail: "suffescom@gmail.com",
      Date: "June 1, 2020, 08:22 AM",
    },
    {
      title: "publishing and graphic design, Lorem ipsum...",
      PostImg:
        "https://image.shutterstock.com/image-photo/full-hd-image-ladybird-on-260nw-1952398060.jpg",
      UserImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      UserName: "Jane Cooper",
      UserEmail: "suffescom@gmail.com",
      ArtistImg:
        "https://cdn.pixabay.com/photo/2018/01/14/23/12/nature-3082832_1280.jpg",
      ArtistName: "Jane Cooper",
      ArtistEmail: "suffescom@gmail.com",
      Date: "June 1, 2020, 08:22 AM",
    },
  ];
  return (
    <>
      <div className="CommonTable">
        <div className="table-responsive">
          <table className="table">
            <thead className="">
              <tr>
                <th className="border-0">S.No.</th>
                <th className="border-0">User details</th>
                <th className="border-0">Post</th>
                <th className="border-0">Artist Details</th>
                <th className="border-0">Date</th>
                <th className="border-0">Action</th>
              </tr>
            </thead>
            <tbody>
              {tableData?.map((data) => {
                const postDetails = data?.postDetails;
                const userDetails = data?.userDetails;
                const artistDetails = postDetails?.userDetails;

                return (
                  <tr>
                    <td className="border-0">{tableData.indexOf(data) + 1}</td>
                    <td className="border-0">
                      <div className="d-flex align-items-center gap-10 tableProfile">
                        <div className="imgWrp">
                          <img
                            src={
                              userDetails?.profileImage
                                ? userDetails?.profileImage
                                : User
                            }
                            alt=""
                            className="img-fluid rounded-circle"
                          />
                        </div>
                        <div className="content">
                          <h6 className="m-0 fw-bold">
                            {userDetails?.firstName +
                              " " +
                              userDetails?.lastName}
                          </h6>
                          <p className="m-0">{userDetails?.userName}</p>
                        </div>
                      </div>
                    </td>
                    <td className="border-0 ws-normal">
                      <div className="d-flex align-items-center gap-10 profile">
                        <div className="imgWrp">
                          <PostHandler data={postDetails} />
                        </div>
                        <div className="tableTitle">
                          {postDetails?.description}
                        </div>
                      </div>
                    </td>
                    <td className="border-0">
                      <div className="d-flex align-items-center gap-10 tableProfile">
                        <div className="imgWrp">
                          <img
                            src={
                              artistDetails?.profileImage
                                ? artistDetails?.profileImage
                                : User
                            }
                            alt=""
                            className="img-fluid rounded-circle"
                          />
                        </div>
                        <div className="content">
                          <h6 className="m-0 fw-bold">
                            {artistDetails?.firstName +
                              " " +
                              artistDetails?.lastName}
                          </h6>
                          <p className="m-0">{artistDetails?.userName}</p>
                        </div>
                      </div>
                    </td>

                    <td className="border-0">
                      {moment(data?.createdAt).format("MM/DD/YYYY")}
                    </td>
                    <td className="border-0">
                      <div className="d-flex align-items-center justify-content-center gap-10">
                        <Button
                          variant="transparent"
                          className="border-0 p-0"
                          onClick={() => deleteCommentPost(data)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="17"
                            viewBox="0 0 16 17"
                            fill="none"
                          >
                            <path
                              d="M7.71062 5.81438e-09C8.4026 -4.53024e-05 9.06838 0.264707 9.57136 0.739946C10.0743 1.21518 10.3764 1.86488 10.4156 2.55576L10.4198 2.70914H14.796C14.9544 2.70918 15.1069 2.76936 15.2227 2.8775C15.3384 2.98563 15.4088 3.13368 15.4196 3.29171C15.4304 3.44974 15.3808 3.60598 15.2808 3.72885C15.1809 3.85173 15.038 3.93208 14.8811 3.95367L14.796 3.95951H14.1325L13.0655 14.8127C13.0121 15.3538 12.768 15.8583 12.377 16.236C11.9859 16.6138 11.4733 16.8403 10.9307 16.875L10.784 16.88H4.63721C4.09326 16.88 3.56705 16.6865 3.15261 16.3342C2.73816 15.982 2.46249 15.4938 2.37487 14.9569L2.3557 14.8119L1.28788 3.95951H0.625185C0.474109 3.9595 0.328146 3.90479 0.214288 3.80549C0.10043 3.70619 0.0263814 3.56902 0.00583504 3.41935L0 3.33432C6.37097e-06 3.18324 0.0547184 3.03728 0.154018 2.92342C0.253318 2.80957 0.390488 2.73552 0.54016 2.71497L0.625185 2.70914H5.00148C5.00148 1.99063 5.28691 1.30155 5.79497 0.793487C6.30303 0.285426 6.99211 5.81438e-09 7.71062 5.81438e-09ZM12.8763 3.95951H2.54409L3.60023 14.6894C3.62362 14.9288 3.72912 15.1527 3.89884 15.3232C4.06856 15.4937 4.29203 15.6002 4.53134 15.6246L4.63721 15.6296H10.784C11.2842 15.6296 11.7085 15.2754 11.8052 14.7944L11.8218 14.6894L12.8755 3.95951H12.8763ZM9.16938 6.25185C9.32046 6.25186 9.46642 6.30657 9.58028 6.40587C9.69414 6.50517 9.76819 6.64234 9.78873 6.79201L9.79457 6.87704V12.7121C9.79452 12.8705 9.73435 13.023 9.62621 13.1387C9.51807 13.2545 9.37003 13.3248 9.212 13.3356C9.05396 13.3464 8.89773 13.2968 8.77485 13.1969C8.65197 13.0969 8.57162 12.954 8.55003 12.7971L8.5442 12.7121V6.87704C8.5442 6.71123 8.61007 6.55221 8.72731 6.43496C8.84456 6.31772 9.00357 6.25185 9.16938 6.25185ZM6.25185 6.25185C6.40293 6.25186 6.54889 6.30657 6.66275 6.40587C6.77661 6.50517 6.85066 6.64234 6.8712 6.79201L6.87704 6.87704V12.7121C6.87699 12.8705 6.81682 13.023 6.70868 13.1387C6.60054 13.2545 6.4525 13.3248 6.29446 13.3356C6.13643 13.3464 5.98019 13.2968 5.85732 13.1969C5.73444 13.0969 5.65409 12.954 5.6325 12.7971L5.62667 12.7121V6.87704C5.62667 6.71123 5.69253 6.55221 5.80978 6.43496C5.92702 6.31772 6.08604 6.25185 6.25185 6.25185ZM7.71062 1.25037C7.34452 1.25038 6.99181 1.38805 6.7225 1.63605C6.45319 1.88405 6.28698 2.22424 6.25685 2.5891L6.25185 2.70914H9.16938C9.16938 2.32225 9.01569 1.9512 8.74212 1.67763C8.46855 1.40406 8.09751 1.25037 7.71062 1.25037Z"
                              fill="black"
                            />
                          </svg>
                        </Button>
                        <Button
                          variant="transparent"
                          className="border-0 p-0 btn "
                          onClick={() => handlePostDetails(postDetails)}
                        >
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="23"
                            height="22"
                            viewBox="0 0 23 22"
                            fill="none"
                          >
                            <g clip-path="url(#clip0_0_1826)">
                              <path
                                d="M21.3845 10.7662C20.5759 8.67463 19.1721 6.8658 17.3467 5.56331C15.5212 4.26082 13.3541 3.52177 11.1132 3.4375C8.87234 3.52177 6.70525 4.26082 4.87981 5.56331C3.05437 6.8658 1.65059 8.67463 0.841983 10.7662C0.787373 10.9173 0.787373 11.0827 0.841983 11.2338C1.65059 13.3254 3.05437 15.1342 4.87981 16.4367C6.70525 17.7392 8.87234 18.4782 11.1132 18.5625C13.3541 18.4782 15.5212 17.7392 17.3467 16.4367C19.1721 15.1342 20.5759 13.3254 21.3845 11.2338C21.4391 11.0827 21.4391 10.9173 21.3845 10.7662ZM11.1132 17.1875C7.46948 17.1875 3.61948 14.4856 2.22386 11C3.61948 7.51437 7.46948 4.8125 11.1132 4.8125C14.757 4.8125 18.607 7.51437 20.0026 11C18.607 14.4856 14.757 17.1875 11.1132 17.1875Z"
                                fill="black"
                              />
                              <path
                                d="M11.1133 6.875C10.2974 6.875 9.49991 7.11693 8.82156 7.57019C8.1432 8.02345 7.61449 8.66769 7.30228 9.42143C6.99007 10.1752 6.90838 11.0046 7.06754 11.8047C7.22671 12.6049 7.61958 13.3399 8.19647 13.9168C8.77336 14.4937 9.50836 14.8866 10.3085 15.0457C11.1087 15.2049 11.9381 15.1232 12.6919 14.811C13.4456 14.4988 14.0898 13.9701 14.5431 13.2917C14.9964 12.6134 15.2383 11.8158 15.2383 11C15.2383 9.90598 14.8037 8.85677 14.0301 8.08318C13.2565 7.3096 12.2073 6.875 11.1133 6.875ZM11.1133 13.75C10.5694 13.75 10.0377 13.5887 9.58546 13.2865C9.13323 12.9844 8.78075 12.5549 8.57261 12.0524C8.36447 11.5499 8.31001 10.9969 8.41612 10.4635C8.52223 9.93005 8.78414 9.44005 9.16874 9.05546C9.55333 8.67086 10.0433 8.40895 10.5768 8.30284C11.1102 8.19673 11.6632 8.25119 12.1657 8.45933C12.6682 8.66747 13.0977 9.01995 13.3998 9.47218C13.702 9.92442 13.8633 10.4561 13.8633 11C13.8633 11.7293 13.5736 12.4288 13.0578 12.9445C12.5421 13.4603 11.8426 13.75 11.1133 13.75Z"
                                fill="black"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_0_1826">
                                <rect
                                  width="22"
                                  height="22"
                                  fill="white"
                                  transform="translate(0.113281)"
                                />
                              </clipPath>
                            </defs>
                          </svg>
                        </Button>
                      </div>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        {/* <div className="d-flex align-items-center justify-content-between gap-10 flex-wrap paginationWrpper mt-2 bg-white pt-3">
          <div className="left">
            <div className="showResult d-flex align-items-center gap-10">
              <label htmlFor="" className="form-label m-0">
                Show Result:
              </label>
              <Form.Select
                aria-label="Default select example"
                value={filter.limit}
                onChange={(e) => setFilter({ limit: e.target.value })}
              >
                {[10, 20, 30, 50]?.map((itm) => (
                  <option value={itm}>{itm}</option>
                ))}
              </Form.Select>
            </div>
          </div>
          <div className="right ">
            <Pagination>
              <Pagination.Prev onClick={handlePreviousClick} />
              {Array.from(Array(props.totalPage).keys())?.map((page, index) => {
                var pageNo = page + 1;
                return (
                  <Pagination.Item
                    active={pageNo == filter.page}
                    onClick={() => setFilter({ page: pageNo })}
                  >
                    {pageNo}
                  </Pagination.Item>
                );
              })}
              <Pagination.Next onClick={handleNextClick} />
            </Pagination>
          </div>
        </div> */}

        <CustomPagination
          totalPage={props.totalPage}
          setFilter={setFilter}
          filter={filter}
        />
      </div>
    </>
  );
};

export default CommentPost;
